import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupRestrictedActionsContentProps } from './msg-group-restricted-actions-content';
import { MsgGroupRestrictedActionsContent } from './msg-group-restricted-actions-content';

export interface MsgGroupRestrictedActionsPreviewProps
  extends MsgGroupRestrictedActionsContentProps {}

export const MsgGroupRestrictedActionsPreview = memo(function MsgGroupRestrictedActionsPreview({
  message,
}: MsgGroupRestrictedActionsPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupRestrictedActionsContent message={message} />
    </LastMessageSystem>
  );
});
